<mat-form-field appearance="outline"
                floatLabel="always"
                id="input-component-root"
                class="input-component-root"
                [ngClass]="{'disabled': disabled, readonly}">
  <mat-label>{{label}}</mat-label>
  <textarea *ngIf="isTextArea"
            matInput
            [formControl]="control"
            [required]="required"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="10"></textarea>
  <input *ngIf="isNormalInput"
         [type]="calculatedType"
         matInput
         [formControl]="control"
         [required]="required"
         [readonly]="readonly"
         [maxLength]="maxLength"
         [autocomplete]="autocompleteValue"
         (paste)="onPaste($event)">
  <input *ngIf="isDatePicker"
         [type]="calculatedType"
         matInput
         [formControl]="control"
         [required]="required"
         [readonly]="readonly"
         [matDatepicker]="datepicker"
         (focus)="datepicker?.open()"
         (click)="datepicker?.open()"
         [max]="maxDate">
  <input *ngIf="isPhoneNumber"
         [type]="calculatedType"
         matInput
         [formControl]="control"
         [required]="required"
         [readonly]="readonly"
         [maxLength]="maxLength"
         [autocomplete]="autocompleteValue"
         [mask]="mask">
  <mat-icon matSuffix
            (click)="togglePasswordVisibility()"
            *ngIf="isPassword()">
    {{getPasswordIcon()}}
  </mat-icon>
  <mat-spinner matSuffix
               [diameter]="15"
               class="mat-spinner-loading"
               *ngIf="isLoading()">
  </mat-spinner>
  <mat-error>{{errorMessage}}</mat-error>
  <mat-hint *ngIf="hasHint()">{{hint}}</mat-hint>
</mat-form-field>
